import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { MarketInfoService } from '../services/MarketInfoService.service';
import { Subscription } from 'rxjs';
import { UserService } from '../services/User.service';
import Swal from 'sweetalert2';
import { GeneralService } from '../services/General.service';
import { RentalService } from '../services/Rental.service';

@Component({
  selector: 'app-rental-menu',
  templateUrl: './rental-menu.component.html',
  styleUrls: ['./rental-menu.component.scss']
})
export class RentalMenuComponent implements OnInit, OnDestroy {
  @Input() IsVendorLogin;
  marketId;
  imageUrl= "";
  vendorId=0;
  private subscriptions: Subscription[] = [];
  allowRegisterVendor = false;
  allowNewVendorBooking = false;
  activeRoute: string = '';
  vendorTerm = "Vendor";
  companyId;
  validURL = false;
  EnableVendorApplication: any;
  EnableWRQBR: any = false;
  HideWRMarketMap: boolean = false;
  @Output() companyIdSevenMile = new EventEmitter<number>();
  
  constructor(
    private route: ActivatedRoute,
    private userService:UserService,
    private router:Router,
    private generalService: GeneralService,
    private marketInfoService:MarketInfoService,
    private operationRentalService: RentalService,) {}

  ngOnInit(): void {
    this.getCompanyId();
    this.subscriptions.push(this.route.params.subscribe((params: Params) => {
      this.marketId = params['marketId'] ?? this.userService.getMarketId();
    }));
    if (!this.router.url.includes("pageNotFound")) {
        this.subscriptions.push(this.generalService.ValidateWRMarketByCompanyId(this.marketId).subscribe((res) => {
        if (res.Success) {
          this.validURL = true;
          this.getWebRentalSetting();
          this.getCustomSettings();
          this.getMarketLogo();
          // FIX: keep the subscription so it is removed when the menu is destroyed. Before, every
          // page that shows the menu added another router listener that was never removed.
          this.subscriptions.push(this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              this.activeRoute = this.router.url;
            }
          }));
        } else {
          this.validURL = false;
          this.router.navigate(['/pageNotFound/0']);
        }
      }));
    } else {
      this.validURL = false;
      this.router.navigate(['/pageNotFound/0']);
    }
  }  

  getMarketLogo() {
    const timestamp = new Date().getTime();
    const sub = this.marketInfoService.getMarketLogo(this.marketId).subscribe((res: any) => {
      if (res) {
          this.imageUrl = res.MarketLogoBlobURL + `?timestamp=${timestamp}`;
      }
      else {
        this.imageUrl = '../../../assets/images/NoImage.jpg'
      }
    });
    this.subscriptions.push(sub);
  }

  getWebRentalSetting(){
    const sub = this.marketInfoService.getWebRentalSetting(this.marketId).subscribe((res: any) => {
      if (res) {
        this.allowRegisterVendor =res.VendorRegistration;
        this.allowNewVendorBooking = res.AllowNewVendorBooking;
        this.vendorTerm = res.WebRentalVendorTermText;
        this.EnableVendorApplication = res.EnableVendorApplication;
        this.HideWRMarketMap = res.HideWRMarketMap;
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  getCustomSettings() {
    this.subscriptions.push(this.operationRentalService.getCustomSettings(this.marketId).subscribe((res: any) => {
      if (res) {
        this.EnableWRQBR = res.EnableWRQBR;
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  isActiveRoute(route: string): boolean {
    return this.router.url.includes(route);
  }

  changeRentalMenu(pagename) {
    var token = localStorage.getItem('token');
    if (token && this.router.url.includes("rent-online")) {
      if(pagename == "login"){
        return false;
      }
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Navigating to other page will log you out from the application. Are you sure you want to logout?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,

      }).then((result) => {
        if (result.value) {
          this.userService.clearToken();
          this.userService.clearSession();
          if (pagename == "newven-online") {
            this.router.navigate(['/' + pagename,  this.marketId]);
          } else
            this.router.navigate(['/' + pagename, this.marketId]);
        }
        else {
          return false;
        }
      })
    } else if (token && this.router.url.includes("deactivated")) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Navigating to another page will cancel your registration. Are you sure you want to cancel?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,

      }).then((result) => {
        if (result.value) {
          this.userService.clearToken();
          this.userService.clearSession();
          if (pagename == "newven-online") {
            this.router.navigate(['/' + pagename, this.marketId]);
          } else
            this.router.navigate(['/' + pagename, this.marketId]);
        }
        else {
          return false;
        }
      })
    }
    else {
      if (pagename == "newven-online") {
        this.router.navigate(['/' + pagename,  this.marketId]);
      } else
        this.router.navigate(['/' + pagename, this.marketId]);
    }
  }

  checkVendorLoggedIn() {
    var token = localStorage.getItem('token');
    if (token && this.router.url.includes("rent-online"))
      return true;
    else
      return false;
  }

  logout() {
    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you want to logout?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {
        this.userService.clearToken();
        var url = '/login/' + this.marketId;
        this.router.navigate([url]);
      } else {
        return;
      }
    });
  }

  getCompanyId() {
    this.subscriptions.push(this.generalService.getCompanyId().subscribe((response:any) => {
      this.companyId = response.Id;
      this.companyIdSevenMile.emit(this.companyId);
    }));
  } 
}